import { NgModule } from '@angular/core';
import { CityDataAccessModule } from '@city/data-access';
import { CityFeatureModule } from '@city/feature';
import { CityUiModule } from '@sdvor/city/ui';

@NgModule({
  imports: [CityFeatureModule, CityDataAccessModule, CityUiModule],
})
export class SdvorCityShellModule {}
